import Axios from "axios";

const apiInstance = Axios.create();

const rejectPublicApiError = (err, message) => {
  const responseData = err.response?.data ?? {};
  const error = new Error(message);
  if (typeof responseData.code === "string") {
    error.code = responseData.code;
  }
  if (err.response?.status != null) {
    error.status = err.response.status;
  }
  return Promise.reject(error);
};

apiInstance.interceptors.response.use(
  response => response,
  err => {
    // No response at all (network failure, timeout, CORS, offline): do not
    // dereference err.response — it would throw a TypeError and surface a
    // stale/incorrect form error (e.g. "invalid password" on a dropped login).
    if (!err.response) {
      return Promise.reject(new Error("networkError"));
    }
    if (!err.response.data?.message || err.code === "ERR_BAD_RESPONSE") {
      return rejectPublicApiError(err, "internalError");
    }
    return rejectPublicApiError(err, err.response.data.message);
  }
);

export default apiInstance;
